<template>
    <div v-show="isModalVisible">
        <div class="modal-mask" @click="closeModal">
            <div class="modal-container" @click.stop>
                <!-- Modal Header -->
                <div class="modal-header">
                    <h6 class="modal-title">Change Password</h6>
                    <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="edit-profile-form">
                        <form @submit.prevent="onUpdate">
                            <div class="row margin-bottom-15">
                            <div class="col-12 col-sm-12">
                            <label
                                for="first_name"
                                class="col-12 input_label">New Password:<span class="required">*</span></label>
                            <input
                            type="password"
                            name="password"
                            id="password"
                            class="col-12 col-sm-12 form-control"
                            v-validate="'required|min:10|special_char|number'"
                            v-model="password"
                            ref="password"
                            data-vv-as="New Password"
                            maxlength="20">

                            <div v-show="verrors.has('password')" class="validate-warning-msg">{{ verrors.first('password') }}</div>

                              <div 
                                class="ml-2 mt-2" 
                                :class="password && passwordLengthValid ? 'text-success' : (password && !passwordLengthValid ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
                                <i 
                                  class="fa mr-1" 
                                  :class="password && passwordLengthValid ? 'fa-check-circle' : (password && !passwordLengthValid ? 'fa-times' : '')"></i>
                                10 or more characters
                              </div>

                              <div 
                                class="ml-2" 
                                :class="password && containsSpecialChar ? 'text-success' : (password && !containsSpecialChar ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
                                <i 
                                  class="fa mr-1" 
                                  :class="password && containsSpecialChar ? 'fa-check-circle' : (password && !containsSpecialChar ? 'fa-times' : '')"></i>
                                1 or more special characters (*,!,#, etc)
                              </div>

                              <div 
                                class="ml-2 mb-0" 
                                :class="password && containsNumber ? 'text-success' : (password && !containsNumber ? 'text-danger' : 'text-muted')" style="margin-left: 0 !important;">
                                <i 
                                  class="fa mr-1" 
                                  :class="password && containsNumber ? 'fa-check-circle' : (password && !containsNumber ? 'fa-times' : '')"></i>
                                1 or more numbers
                              </div>

                            </div>
                            </div>
                            <div class="row margin-bottom-15">
                            <div class="col-12 col-sm-12">
                            <label
                                for="last_name"
                                class="col-12 input_label">Confirm Password:<span class="required">*</span></label>
                            <input
                                type="password"
                                name="confirm_password"
                                id="confirm_password"
                                class="col-12 col-sm-12 form-control"
                                v-validate="'required|confirmed:password|min:6'"
                                v-model="confirm_password"
                                ref="confirm_password"
                                data-vv-as="Confirm password"
                                maxlength="20">
                          <div v-if="verrors.firstByRule('confirm_password', 'required')" class="margin-bottom-5 validate-warning-msg">
                            The Confirm Password field is required</div>
                          <div v-if="verrors.firstByRule('confirm_password', 'confirmed')" class="margin-bottom-5 validate-warning-msg">The New Password and Confirm Password does not match</div>                  

                            </div>
                            </div>
                            <div class="submit margin-bottom-15 text-center">
                            <button type="submit" class="btn btn-sm btn-blue submit_btn text-center">Confirm</button>
                            </div>
                            <div style="clear: both"></div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
export default {
    props: ['isModalVisible'],
    data() {
        return {
            password: '',
            confirm_password: '',
        }
    },
  computed: {
    passwordLengthValid() {
      return this.password.length >= 10;
    },
    containsSpecialChar() {
      return /[!@#$%^&*]/.test(this.password);
    },
    containsNumber() {
      return /[0-9]/.test(this.password);
    }
  },
    methods: {
        navigate(pathUrl) {
            this.$router.push(pathUrl)
            this.$router.go();
        },
        closeModal() {
            this.$validator.errors.clear();
            this.$emit('close');
        },
        onUpdate () {
            this.$validator.validateAll().then((result) => {
                if(!result){
                    return;
                }
                this.update();
            }).catch(() => {
                // catches the error;
            });
        },
        update: function () {
            axios('/password-update',
                {
                method: 'PATCH',
                data: {password: this.password},
                }
            )
            .then((resp) => {
                this.$store.dispatch('logout');
                this.flash({ message: 'Your password is changed. Please login.', variant: 'success' });
                this.closeModal();
                this.navigate("/login");
            })
            .catch(error => {

            });
        },
    }
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.edit-profile-form {
  font-size: 13px; 
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.input_label {
  font-weight: 900;
  padding: 0;
}
.input_label span {
  font-weight: normal;
}
.submit_btn {
  color: #FFF; 
  border-radius: 10px;
  font-weight: 900;
  width: 150px;
}
.task_name {
  font-size: 14px;
}
.custom_hr {
  border-bottom: 1px solid #00acee;
  margin: 10px 0px;
  width: 100%;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.text-danger { color: #FF0000 !important; }
</style>


// WEBPACK FOOTER //
// src/components/update_password.vue